import './assets/index.css'
import Vue from 'vue'

/*导入router*/
import router from './router/index'

/*导入element-ui*/
import './plugins/element'

/*注册自定义组件*/
import './components/index'

import store from './store'

import axios from 'axios'

import qs from 'qs'

import { ServerFail } from './common/ServerFail.ts'

Vue.prototype.$isServerFail = function (error) {
	return error && error.name == 'ServerFail'
}

Vue.prototype.$apiGet = function (url, data) {
	return new Promise((resolve, reject) => {
		if (typeof data == 'object') {
			url = url + '?' + qs.stringify(data)
		}
		axios.get(url).then(resp => {
			if (resp.data.code == 0) {
				resolve(resp.data.data)
			} else {
				var msg = resp.data.msg || '服务端处理失败'
				reject(new ServerFail(msg))
			}
		}).catch(error => {
			alert('请求发生异常：' + error.message)
			console.error(error)
			reject(error)
		})
	})
}

Vue.prototype.$apiPost = function (url, data, config) {
	return new Promise((resolve, reject) => {
		axios.post(url, data, config).then(resp => {
			if (resp.data.code == 0) {
				resolve(resp.data.data)
			} else {
				var msg = resp.data.msg || '服务端处理失败'
				reject(new Error(msg))
			}
		}).catch(error => {
			alert('请求发生异常：' + error.message)
			console.error(error)
			reject(error)
		})
	})
}
Vue.config.productionTip = false
new Vue({
	router,
	store,
	data() {
		return {
			env: process.env
		}
	},
	render(h) { return h(require('./App.vue').default) },
}).$mount('#app')
